/* Old Gold Exchange feature — Manik Chand Jewellers */
(function () {
  var WHATSAPP_NUMBER = '919339293311';      // WhatsApp Business number (intl format, digits only)
  var LEAD_WEBHOOK = 'https://manikchand.app.n8n.cloud/webhook/exchange-lead'; // n8n lead-capture webhook

  var c = document.querySelector('.tq-pdp-exchange-container');
  if (!c) return;

  var modal = c.querySelector('.exchange-modal');
  var step1 = c.querySelector('.step-1');
  var step2 = c.querySelector('.step-2');
  var step3 = c.querySelector('.step-3');

  var values = {};
  try { values = JSON.parse(c.getAttribute('data-values') || '{}'); } catch (e) {}
  var type = (c.getAttribute('data-type') || '').toUpperCase();
  var productKarat = c.getAttribute('data-karat') || '';
  var product = c.getAttribute('data-product-title') || '';
  var productId = c.getAttribute('data-product-id') || '';
  var pay = values.pay || '';
  var selectedKarat = null;

  // Banner: show grams needed for the product's own karat
  var bannerGrams = c.querySelector('.ex-grams');
  if (bannerGrams && values[productKarat]) bannerGrams.textContent = values[productKarat];

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function openModal() {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (type === 'DIAMOND' || type === 'GEMSTONE') { hide(step1); show(step2); }
    else { show(step1); hide(step2); }
    hide(step3);
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    show(step1); hide(step2); hide(step3);
    step2.querySelectorAll('input').forEach(function (i) { i.value = ''; });
    var er = step2.querySelector('.exchange-error'); if (er) er.hidden = true;
    selectedKarat = null;
  }

  c.querySelector('.exchange-open-btn').addEventListener('click', openModal);
  c.querySelector('.exchange-close-btn').addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  step1.querySelectorAll('.select-carat').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedKarat = this.getAttribute('data-caratvalue');
      hide(step1); show(step2);
    });
  });

  c.querySelector('.exchange-submit-btn').addEventListener('click', function () {
    var name = (step2.querySelector('.ex-name').value || '').trim();
    var phone = (step2.querySelector('.ex-phone').value || '').trim();
    var pin = (step2.querySelector('.ex-pincode').value || '').trim();
    var er = step2.querySelector('.exchange-error');
    var msg = '';
    if (!/^[a-zA-Z ]+$/.test(name)) msg = 'Please enter a valid name.';
    else if (!/^[0-9]{10}$/.test(phone)) msg = 'Phone must be 10 digits.';
    else if (!/^[0-9]{6}$/.test(pin)) msg = 'Pin code must be 6 digits.';
    if (msg) { er.textContent = msg; er.hidden = false; return; }
    er.hidden = true;

    var karat = selectedKarat || productKarat || '22';
    var grams = values[karat] || '';
    step3.querySelector('.gold-plain-updated-value').textContent = '₹' + pay;
    step3.querySelector('.ex-final-grams').textContent = grams;
    step3.querySelector('.gold-plain-final-karat').textContent = karat + 'k gold';

    var text = 'Hi Manik Chand Jewellers, I want to use the Old Gold Exchange for ' + product +
      '. I will pay ₹' + pay + ' in cash and bring about ' + grams + 'g of ' + karat +
      'k old gold. Name: ' + name + ', Phone: ' + phone + ', Pincode: ' + pin + '. Please confirm.';
    c.querySelector('.exchange-whatsapp-btn')
      .setAttribute('href', 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(text));

    hide(step2); show(step3);

    if (LEAD_WEBHOOK) {
      fetch(LEAD_WEBHOOK, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product: product, productId: productId, karat: karat, gramsNeeded: grams, payCash: pay,
          name: name, phone: phone, pincode: pin, time: new Date().toISOString()
        })
      }).catch(function () {});
    }
  });
})();
